import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import RivalzApi from "../../../config/axios/RivalzApi";
import useConnection from "../../../config/zustand";
import MDTypography from "../../../components/MDTypography";
import rivalzLogo from "../../../assets/images/logos/rivalz-logo.png";
import Button from "@mui/material/Button";
import MDInput from "../../../components/MDInput";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { useAccount } from "wagmi";
import { useConnectModal } from "@rainbow-me/rainbowkit";
import { signMessage } from "@wagmi/core";
import config from "../../../config/RainBowConfig";
import metamaskIcon from "../../../assets/images/metamask.svg";

function Basic() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { setJwt } = useConnection();
  const queryClient = useQueryClient();
  const { address, isConnected } = useAccount();
  const { openConnectModal } = useConnectModal();

  const sign = async () => {
    try {
      if (!email || !password) {
        toast.error("Email and password are required");
        return;
      }
      const res = await RivalzApi.login({
        email,
        password,
      });
      const token = res.accessToken;
      setJwt(token);
      localStorage.setItem("jwtToken", token);
      await queryClient.refetchQueries({ queryKey: ["encryptedKeyStatus"] });
    } catch (error) {
      toast.error(error.message);
    }
  };

  const logInWithWallet = async () => {
    try {
      if (!isConnected) {
        openConnectModal();
        return;
      }
      await signWithWallet();
    } catch (error) {
      console.error("Error signing message: ", error);
    }
  };

  const signWithWallet = async () => {
    try {
      const message = `Sign this message to prove you own this address on Rivalz Dev on ${new Date().toLocaleString()}`;
      const signature = await signMessage(config, {
        message,
      });
      const res = await RivalzApi.loginWithWallet({
        dataSign: message,
        signature,
        address,
        referralId: "",
      });
      const token = res.accessToken;
      setJwt(token);
      localStorage.setItem("jwtToken", token);
    } catch (error) {
      toast.error(error.message);
    }
  };

  useEffect(() => {
    if (isConnected) {
      signWithWallet();
    }
  }, [isConnected]);
  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox mb={3} display={"flex"} gap={1} justifyContent="center" alignItems="center">
            <MDBox component="img" src={rivalzLogo} alt="Brand" width="2rem" />
            <MDBox>
              <MDTypography variant="caption" fontWeight="medium">
                {"Rivalz Console"}
              </MDTypography>
            </MDBox>
          </MDBox>
          <MDBox mb={5} style={{ textAlign: "center" }}>
            <MDTypography variant="h6" fontWeight="medium">
              Welcome to Rivalz Console
            </MDTypography>
            <MDTypography variant="caption" fontWeight="regular" color="text">
              Sign in to your account
            </MDTypography>
          </MDBox>
          <MDBox mb={2}>
            <MDInput
              type="email"
              label="Email"
              fullWidth
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
          </MDBox>
          <MDBox mb={2}>
            <MDInput
              type="password"
              label="Password"
              fullWidth
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />
          </MDBox>
          <MDBox display={"flex"} justifyContent="center" alignItems="center">
            <Button
              variant="contained"
              onClick={sign}
              fullWidth={true}
              style={{ backgroundColor: "#4CAF50", color: "#fff" }}
            >
              Login
            </Button>
          </MDBox>
          <MDBox mt={1} mb={1} textAlign="center">
            <MDTypography variant="button" color="text">
              Or
            </MDTypography>
          </MDBox>
          <MDBox display={"flex"} justifyContent="center" alignItems="center">
            <Button
              variant="contained"
              onClick={logInWithWallet}
              fullWidth={true}
              style={{ backgroundColor: "#ffb41e", color: "#fff" }}
              startIcon={<img src={metamaskIcon} alt="metamask" width="20" />}
            >
              Login with Metamask
            </Button>
          </MDBox>
          <MDBox mt={3} mb={1} textAlign="center">
            <MDTypography variant="button" color="text">
              Don&apos;t have an account?{" "}
              <MDTypography
                component={Link}
                to="/authentication/sign-up"
                variant="button"
                color="info"
                fontWeight="medium"
                textGradient
              >
                Sign up
              </MDTypography>
            </MDTypography>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
